import { Text } from "ui-kit/components-branded/index"
import { formatToLong } from "utils/datetime-format-utils"

interface Props {
    sessionDatetime: string
    sessionDuration: number
}

export function SessionInfo({ sessionDatetime, sessionDuration }: Props) {
    return (
        <div>
            <Text>{formatToLong(sessionDatetime)}</Text> <br />
            <Text color="secondary">Длительность {sessionDuration}&nbsp;минут</Text>
        </div>
    )
}
